import React from 'react'
// import Resort from "../../assets/img/bg/an-img-02.png"
import Resort1 from "../../assets/img/features/estiloyconcepto.jpg"

function Luxury() {
  return (
    <>
        <section className="feature-area2 p-relative fix" style={{background: "#f7f5f1"}}>
                 {/* <div className="animations-02"><img src={Resort} alt="contact-bg-an-05"/></div> */}
                <div className="container">
                    <div className="row justify-content-center align-items-center">
                         <div className="col-lg-6 col-md-12 col-sm-12 pr-30">
                           <div className="feature-img">                               
                                <img src={Resort1} alt="img" className="img"/>              
                            </div>
                        </div>
					   <div className="col-lg-6 col-md-12 col-sm-12">
                            <div className="feature-content s-about-content">
                                <div className="feature-title pb-20">                               
                                    <h5>Hotel La Finca</h5>
                                <h2>
                                 Estilo y Concepto
                                </h2>                             
                                </div>
                                <p>El hotel combina arquitectura colonial con un diseño moderno, creando un ambiente
                                sofisticado y elegante que rinde homenaje a la historia de la región.</p>
                                <p>Su diseño está
inspirado en las haciendas tradicionales, incorporando materiales como cantera, madera y
hierro forjado, pero con un enfoque contemporáneo en mobiliario, iluminación y tecnología.</p>
                                {/* <div className="slider-btn mt-15">                                          
                                    <Link to="/about" className="btn ss-btn smoth-scroll">Ver Más</Link>				
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>
        </section>
    </>
  )
}

export default Luxury